import { View } from 'foundations-components/components/View';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const PinnedPropertyPopoverButton = props => {
  const {
    children,
    dataTestId,
    disabled,
    prevOperator,
    onClick,
    isOpen
  } = props;
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: prevOperator && 'fill-info-subtle',
    children: /*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      color: "text-interactive-default",
      children: /*#__PURE__*/_jsx(Clickable, {
        "data-test-id": dataTestId,
        "data-test-group": "quick-filter-popover-button",
        onClick: onClick,
        "aria-pressed": isOpen,
        disabled: disabled,
        display: "flex",
        padding: "300",
        alignItems: "center",
        gap: "600",
        children: children
      })
    })
  });
};
export default PinnedPropertyPopoverButton;